export default "__VITE_ASSET__53240afa__"